import {AssetsRequestParams} from "../../../infrastructure/models/params/assets-request-params";

export class ShotMapBallRequestParams extends AssetsRequestParams {
  constructor(width: Number, height: Number) {
    super({width, height});

    this.resourceName = `${this.resourceName}/ShotMap/ball`;
  }
}